import { render, staticRenderFns } from "./bankDirect.vue?vue&type=template&id=49f1e60a&scoped=true&"
import script from "./bankDirect.vue?vue&type=script&lang=js&"
export * from "./bankDirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1e60a",
  null
  
)

export default component.exports